import { render, staticRenderFns } from "./ProductsDeliveryInformation.vue?vue&type=template&id=798eeca2&scoped=true&"
import script from "./ProductsDeliveryInformation.vue?vue&type=script&lang=js&"
export * from "./ProductsDeliveryInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDeliveryInformation.vue?vue&type=style&index=0&id=798eeca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798eeca2",
  null
  
)

export default component.exports